import React, { useState } from "react";

//import PropertyProvider from '../../../services/contracts/PropertyProvider'
// import { OrderDescription } from '../../../services/mocks/MockProperty';
import OrdersDataGridToolbar from "./OrdersDataGridToolbarComponent";
import { PropsFromReduxMyArchives } from "../containers/MyArchivesContainer";
// import MyArchivesDataComponent from './MyArchivesDataComponent'

const MyArchives = (_props: PropsFromReduxMyArchives) => {
  const [appointmentFilter, setAppointmentFilter] = useState(""); //eslint-disable-line
  const [prestationFilter, setPrestationFilter] = useState("Tous");
  const [inputFilter, setInputFilter] = useState("");

  // const myArchives = propertyProvider.getMyArchives();

  // const getArchives = () => {
  //     let archivesSelected: Array<OrderDescription> = []
  //     return getFilteredOrders(myArchives, archivesSelected, appointmentFilter, prestationFilter, inputFilter);
  // }

  const resetFilters = () => {
    setAppointmentFilter("");
    setPrestationFilter("Tous");
    setInputFilter("");
  };

  return (
    <div className="mx-3 mt-5">
      <h1 className="mb-2 text-center text-lg-start d-lg-block">
        Mes archives
      </h1>

      <OrdersDataGridToolbar
        states={{
          setAppointmentFilter,
          setPrestationFilter,
          prestationFilter,
          inputFilter,
          setInputFilter,
          resetFilters,
        }}
      />
      {/* <MyArchivesDataComponent rowProps={getArchives()} /> */}
    </div>
  );
};

export default MyArchives;
